export const emailFrequencyOptions = [
    { "value": "0", "lable": "Please Select" },
    { "value": "Instant", "lable": "Immediately" },
    { "value": "Day", "lable": "Once a day" },
    { "value": "Week", "lable": "Once a week" },
    { "value": "Never", "lable": "Never" },
];